import React from 'react';

const EVENT_TYPES = ['class', 'symposium', 'camp', 'seminar', 'unknown'];

const DISCIPLINES = [
  { value: 'sea_kayaking', label: 'Sea Kayaking' },
  { value: 'whitewater',   label: 'Whitewater' },
  { value: 'canoe',        label: 'Canoe' },
  { value: 'surfski',      label: 'Surfski' },
  { value: 'sup',          label: 'SUP' },
  { value: 'other',        label: 'Other' },
];

const COUNTRIES = [
  { value: 'US', label: 'USA' },
  { value: 'UK', label: 'UK' },
  { value: 'MX', label: 'Mexico' },
  { value: 'IL', label: 'Israel' },
  { value: 'CA', label: 'Canada' },
];

const MONTHS = [
  { value: 1,  label: 'Jan' }, { value: 2,  label: 'Feb' },
  { value: 3,  label: 'Mar' }, { value: 4,  label: 'Apr' },
  { value: 5,  label: 'May' }, { value: 6,  label: 'Jun' },
  { value: 7,  label: 'Jul' }, { value: 8,  label: 'Aug' },
  { value: 9,  label: 'Sep' }, { value: 10, label: 'Oct' },
  { value: 11, label: 'Nov' }, { value: 12, label: 'Dec' },
];

const YEARS = [2026, 2027];

export const LEGEND = [
  { value: 'sea_kayaking', label: 'Sea Kayaking', color: 'var(--sea)',     bg: 'var(--sea-bg)' },
  { value: 'whitewater',   label: 'Whitewater',   color: 'var(--ww)',      bg: 'var(--ww-bg)' },
  { value: 'canoe',        label: 'Canoe',         color: 'var(--canoe)',   bg: 'var(--canoe-bg)' },
  { value: 'surfski',      label: 'Surfski',       color: 'var(--surfski)', bg: 'var(--surfski-bg)' },
  { value: 'sup',          label: 'SUP',           color: 'var(--sup)',     bg: 'var(--sup-bg)' },
  { value: 'other',        label: 'Other',         color: 'var(--other)',   bg: 'var(--other-bg)' },
];

const DISC_CSS = {
  sea_kayaking: 'sea',
  whitewater:   'ww',
  canoe:        'canoe',
  surfski:      'surfski',
  sup:          'sup',
  other:        'other',
};

import CountryChart from './CountryChart';

export default function Filters({ apiFilters, setApiFilters, clientFilters, setClientFilters, totalEvents, undatedCount, noAddressCount, subView, onShowAll, onShowUndated, onShowNoAddress, opportunities }) {
  const containerRef = React.useRef(null);
  const dragging = React.useRef(false);
  const startX = React.useRef(0);
  const startW = React.useRef(0);

  const onMouseDown = React.useCallback((e) => {
    dragging.current = true;
    startX.current = e.clientX;
    startW.current = containerRef.current.offsetWidth;
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';
  }, []);

  React.useEffect(() => {
    const onMouseMove = (e) => {
      if (!dragging.current) return;
      const delta = e.clientX - startX.current;
      const newW = Math.max(180, Math.min(520, startW.current + delta));
      if (containerRef.current) containerRef.current.style.width = newW + 'px';
    };
    const onMouseUp = () => {
      dragging.current = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };
  }, []);

  const updateApi = (key, val) => setApiFilters(f => ({ ...f, [key]: val }));
  const updateClient = (key, val) => setClientFilters(f => ({ ...f, [key]: val }));

  const toggleApiChip = (key, val) => {
    const current = Array.isArray(apiFilters[key]) ? apiFilters[key] : [];
    const next = current.includes(val) ? current.filter(t => t !== val) : [...current, val];
    updateApi(key, next);
  };

  const toggleClientChip = (key, val) => {
    const current = Array.isArray(clientFilters[key]) ? clientFilters[key] : [];
    const next = current.includes(val) ? current.filter(t => t !== val) : [...current, val];
    updateClient(key, next);
  };

  const toggleSingleClient = (key, val) => {
    updateClient(key, clientFilters[key] === val ? null : val);
  };

  const activeTypes      = Array.isArray(apiFilters.types)        ? apiFilters.types        : [];
  const activeDisciplines = Array.isArray(apiFilters.disciplines)  ? apiFilters.disciplines  : [];
  const activeCountries  = Array.isArray(apiFilters.countries)     ? apiFilters.countries    : [];
  const activeMonths     = Array.isArray(clientFilters.months)     ? clientFilters.months    : [];

  return (
    <div className="filters-resizable" ref={containerRef}>
      <aside className="filters">
        <div className="charts-row">
          <div className="mini-chart">
            <div className="mini-chart-title">BY DISCIPLINE</div>
            {['sea_kayaking','whitewater','canoe','surfski','sup','other'].map(disc => {
              const count = (opportunities || []).filter(o => o.opportunity_class === disc).length;
              const total = (opportunities || []).length;
              const colors = {sea_kayaking:'#0057ff',whitewater:'#ff3300',canoe:'#c47800',surfski:'#00998a',sup:'#8800ff',other:'#2d7a2d'};
              const labels = {sea_kayaking:'Sea Kayaking',whitewater:'Whitewater',canoe:'Canoe',surfski:'Surfski',sup:'SUP',other:'Other'};
              return (
                <div key={disc} className="mini-chart-row">
                  <div className="mini-chart-label">{labels[disc]}</div>
                  <div className="mini-chart-bar-wrap">
                    {total > 0 && <div className="mini-chart-bar" style={{width:`${(count/total)*100}%`,background:colors[disc]}} />}
                  </div>
                  <div className="mini-chart-count">{count}</div>
                </div>
              );
            })}
          </div>
          <CountryChart opportunities={opportunities} />
        </div>

        <div className="filter-stats">
          <div className={`filter-stat filter-stat-link ${!subView ? 'filter-stat-active' : ''}`} onClick={onShowAll} title="Show all events">
            <span className="filter-stat-value">{totalEvents ?? 0}</span>
            <span className="filter-stat-label">Events</span>
          </div>
          <div className={`filter-stat filter-stat-link ${subView === 'undated' ? 'filter-stat-active' : ''}`} onClick={onShowUndated} title="View undated events">
            <span className="filter-stat-value">{undatedCount ?? 0}</span>
            <span className="filter-stat-label">Undated</span>
          </div>
          <div className={`filter-stat filter-stat-link ${subView === 'no-address' ? 'filter-stat-active' : ''}`} onClick={onShowNoAddress} title="View events without address">
            <span className="filter-stat-value">{noAddressCount ?? 0}</span>
            <span className="filter-stat-label">No Address</span>
          </div>
        </div>

        <div className="filter-group">
          <label className="filter-label">Keyword</label>
          <input
            className="filter-input"
            type="text"
            placeholder="Search events, outfitters..."
            value={apiFilters.keyword || ''}
            onChange={e => updateApi('keyword', e.target.value)}
          />
        </div>

        <div className="filter-group">
          <label className="filter-label">Event Type</label>
          <div className="filter-chips">
            {EVENT_TYPES.map(t => (
              <button
                key={t}
                className={`chip ${activeTypes.includes(t) ? 'chip-active' : ''}`}
                onClick={() => toggleApiChip('types', t)}
              >
                {t.charAt(0).toUpperCase() + t.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-group">
          <label className="filter-label">Discipline</label>
          <div className="filter-chips">
            {DISCIPLINES.map(d => (
              <button
                key={d.value}
                className={`chip chip-disc ${activeDisciplines.includes(d.value) ? 'chip-disc-active' : ''}`}
                style={{
                  '--disc-color': `var(--${DISC_CSS[d.value] || d.value})`,
                  '--disc-bg': `var(--${DISC_CSS[d.value] || d.value}-bg)`,
                }}
                onClick={() => toggleApiChip('disciplines', d.value)}
              >
                {d.label}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-group">
          <label className="filter-label">Country</label>
          <div className="filter-chips">
            {COUNTRIES.map(c => (
              <button
                key={c.value}
                className={`chip ${activeCountries.includes(c.value) ? 'chip-active' : ''}`}
                onClick={() => toggleApiChip('countries', c.value)}
              >
                {c.label}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-group">
          <label className="filter-label">Year</label>
          <div className="filter-chips">
            {YEARS.map(y => (
              <button
                key={y}
                className={`chip ${clientFilters.year === y ? 'chip-active' : ''}`}
                onClick={() => toggleSingleClient('year', y)}
              >
                {y}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-group">
          <label className="filter-label">Month</label>
          <div className="filter-chips filter-chips-months">
            {MONTHS.map(m => (
              <button
                key={m.value}
                className={`chip ${activeMonths.includes(m.value) ? 'chip-active' : ''}`}
                onClick={() => toggleClientChip('months', m.value)}
              >
                {m.label}
              </button>
            ))}
          </div>
        </div>

        <div className="filter-group">
          <div className="toggle-row">
            <span className="toggle-label">❤️ Liked events only</span>
            <button
              className={`toggle-switch ${clientFilters.likedOnly ? 'toggle-on' : ''}`}
              onClick={() => updateClient('likedOnly', !clientFilters.likedOnly)}
              role="switch"
              aria-checked={!!clientFilters.likedOnly}
            >
              <span className="toggle-thumb" />
            </button>
          </div>
          <div className="toggle-row">
            <span className="toggle-label">Hide events w/o address</span>
            <button
              className={`toggle-switch ${clientFilters.hideNoAddress ? 'toggle-on' : ''}`}
              onClick={() => updateClient('hideNoAddress', !clientFilters.hideNoAddress)}
              role="switch"
              aria-checked={!!clientFilters.hideNoAddress}
            >
              <span className="toggle-thumb" />
            </button>
          </div>
          <div className="toggle-row">
            <span className="toggle-label">Hide undated events</span>
            <button
              className={`toggle-switch ${clientFilters.hideUndated ? 'toggle-on' : ''}`}
              onClick={() => updateClient('hideUndated', !clientFilters.hideUndated)}
              role="switch"
              aria-checked={!!clientFilters.hideUndated}
            >
              <span className="toggle-thumb" />
            </button>
          </div>
        </div>

        <button
          className="btn-clear"
          onClick={() => {
            setApiFilters({ keyword: '', types: [], disciplines: [], countries: [] });
            setClientFilters({ year: null, months: [], hideNoAddress: false, hideUndated: false, likedOnly: false });
          }}
        >
          Clear all filters
        </button>
      </aside>
      <div className="filters-drag-handle" onMouseDown={onMouseDown} title="Drag to resize" />
    </div>
  );
}
